
import React, { useState, useImperativeHandle, forwardRef, useEffect} from 'react'
import {  Cicon } from './Desc/style'
import closeIcon from '@/img/user-new/close-circle.png'
import styled from "styled-components"
import { jumpTo } from '@/utils'
import { fetchTalentNotify, fetchDonateState } from './../api'
import bridge from '@/config/JSbridge';
import { Toast } from "antd-mobile";
import  bwmodel from '@/config/bwmodel'
// import { fetchTalentAward, fetchDonateState } from '../api'
const newCard = ({token, login},ref) => {
  
  const [descVisible, setDescVisible] = useState(false)
  const [info, setInfo] = useState({})
  const [activateDonate, setActivateDonate] = useState(0)
    const [authRealPerson, setAuthRealPerson] = useState(0)
  useEffect(()=> {

var currentDate = new Date();
var currentYear = currentDate.getFullYear();
var currentMonth = currentDate.getMonth() + 1; 

const name = `active_170_${currentYear}_${currentMonth}`

if(localStorage.getItem(name)) return
     
    fetchTalentNotify({
      activityId: 170,
      lastMonth:'202507'
    })
      .then(res => {
        if(res.data) {
          setInfo(res.data)
          setDescVisible(true)

        localStorage.setItem(name, 1)
          
        }
      })
  }, [])

    useEffect(() => {
      fetchDonateState({})
        .then(res => {
          setActivateDonate(res.activateDonate)
          setAuthRealPerson(res.authRealPerson)
          
        })
    },[])
  function handleShare() {
     let sendData = {
      event: 'postNewUserActivity170',
      params: {
        userAvatar: info.simpleUser.avatar,
        userName: info.simpleUser.nickname,
        reward: info.awardDetail,
        url: `${process.env.REACT_APP_DEMAND_URL}active_170`, // 二维码
      }
    }
    
    bridge.callHandler('nativeEvent', sendData, res => {
      console.log(res);
    })
  }
   useImperativeHandle(ref, () => {
    return {
      show: () => {
        setDescVisible(true)
      }
    }
  })
 
  return (

    <React.Fragment>
      {
        descVisible && <Mask className='mask' />

      }   
      {
        descVisible && <Container>
        <img src={require('../img/Frame.png')} onClick={
          () => {
            console.log('xxxxxx');
            
            handleShare();
          }
            
        } alt='' className='bg'/>
       
        <div className='title'>恭喜获得风云新秀养成计划</div>
        <div className='name'> {info.awardDetail}</div>
        <div className='tips'> 本月10号统一发放</div>
        <div className='btn' onClick={()=> {
 
            if(activateDonate === 1) {
            jumpTo('storm://app/donate/accounthome')
          } else {
            if(bwmodel.compareVersion('6.29.0')) {
              jumpTo(`storm://app/donate/openDonate?authenticationState=${authRealPerson}`)
            } else {
              Toast.info('请先开通赞赏功能')
            }
          }
          
        }}> 查看奖励</div>
        <Cicon src={closeIcon} alt="e"  onClick={() => setDescVisible(false)}></Cicon>

       </Container>
      }
    
    </React.Fragment>
  )
}

export default React.memo(forwardRef(newCard));


export const Mask = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
  z-index: 999;
`

export const Container = styled.div`
  position: fixed;
  top: 50vw;
  left: 0;
  margin: -40% 5vw; 
  width: calc(90vw);
  z-index: 999;
  .title, .name, .tips {
    position: absolute;
    width: 100%;
    text-align: center;
    left: 0;
  }
  .title {
    top: 30vw;
    font-weight: 500;
    font-size: 16px;
    color: #FFF4C8;
    text-align: center;
  }
  .name {
    top: 54vw;
    font-weight: 500;
    text-align: center;
    font-size: 22px;
    line-height: 26px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    color: #FF3D36;
  }
  .tips {
    top: 62vw;
    color: #FF3D36;
    font-size: 12px;
  }
  .btn {
    display: inline-block;
    font-size: 15px;
    color: #7D0000;
    line-height: 18px;
    text-align: center;
    font-style: normal;
     position: absolute;
     top: 68vw;
     right: 40vw;
  }
`



// WEBPACK FOOTER //
// ./src/views/activity_170/componens/shareCard.js